/*
 * Routed Component
 */
(function () {
    'use strict';

    var reviewerMonth = {
        templateUrl: 'app/entities/shared/reviewer-month/reviewer-month.html',
        bindings: {
            onResolveDisabled: '&',   // [UI-VIEW.ATTR]
            onResolveProperties: '&', // [UI-VIEW.ATTR] this is how child state return possible properties to parent
            properties: '<',          // [THIS.RESOLVE] passed in from state.resolve
            propertyId: '<',          // [PARENT.RESOLVE] user selection
            account: '<',             // [THIS.RESOLVE]
        },
        controller: 'SharedController',
    };

    angular
        .module('tyallsApp')
        .component('reviewerMonth', reviewerMonth)
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('app.prop.reviewer-month', {
                    url: '/reviewer-month',
                    views: {
                        'prop@^': 'reviewerMonth',
                    },
                    data: {
                        authorities: [],
                        pageTitle: 'Reports'
                    },
                    resolve: {
                        properties: ['PropertyService', function (PropertyService) {
                            return PropertyService.getAllPropertiesForUser()
                                .then(function (response) {
                                    return response.data;
                                });
                        }],
                        // refactor this
                        account: ['PrincipalService', function (PrincipalService) {
                            return PrincipalService.identity();
                        }]
                    }
                });
        }]);

}());
